
import EDTypography from '../Typography/EDTypography';
import { IRapportMallControl, mallControlInfo } from './RapportMallTypes';

export interface IRapportKontrollHeaderProps {
  value: IRapportMallControl;
}

export const RapportKontrollHeader: React.FC<IRapportKontrollHeaderProps> = ({
  value,
}) => {
  // Check if the control has a Caption property (like TextBox controls)
  const caption = mallControlInfo(value)?.title ?? value.Type;
  return (
    caption &&
    caption !== '' && (
      <EDTypography variant="subtitle2" sx={{ mb: 1 }}>
        {caption}
      </EDTypography>
    )
  );
};
